module.exports = __webpack_public_path__ + "media/src/website/images/locations/oberaudorf/oberaudorf_01-5a8d775308bb583ba06edfaa33f5709d.jpg";